import {Pipe, PipeTransform} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Ttm} from '../classes/ttm';
import {TtmType} from '../classes/ttmtype';
import {PresentTtmTypesPipe} from './present-ttm-types.pipe';

@Pipe({
    name: 'countEnabledTtmTypes'
})
export class CountEnabledTtmTypesPipe implements PipeTransform {

    transform(formGroup: FormGroup, ttmTypes: TtmType[], ttms: Ttm[], ...trigger: unknown[]): number {
        let count = 0;
        const presentTypes = (new PresentTtmTypesPipe()).transform(ttmTypes, ttms);
        Object.keys(formGroup.value).forEach(key => {
            if (formGroup.value[key] && presentTypes.find(ps => ps.key === key)) {
                count++;
            }
        });
        return count;
    }

}
